import { memo, PropsWithChildren,useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const PortalContent = memo((props: PropsWithChildren<{ id: string }>) => {
  const { id } = props;

  const [portalContent, setPortalContent] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // MutationObserver provides a way to watch for DOM changes until we find the desired node.
      const observer = new MutationObserver(() => {
        // this function runs on every mutation that occurs that is observed by the observer
        if (document.getElementById(id)) {
          // when we find the desired mutation we stop watching for changes
          observer.disconnect();
          setPortalContent(true);
        }
      });

      //watch for changes on document body and its children
      observer.observe(document.body, { childList: true, subtree: true });

      // if component dismount we disconnect the observer
      return () => observer.disconnect();
    }
  }, [id]);

  return (
    <>
      {portalContent &&
        createPortal(
          <>
            {portalContent}
            {props.children}
          </>,
          document.getElementById(id)
        )}
    </>
  );
});

PortalContent.displayName = 'PortalContent';

export default PortalContent;
